import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVolumeDownStyle0 = cosmosIconCss;

const CosmosIconVolumeDown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVolumeDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c60443f3b4117b43b81b378b433173212db75071', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c42a64da232a9a6cca1a4801076a7a7c7653ab24', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '06f4b467547e5715eaa5d67c93ccdb03a3bcf9c3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.62 8 2.55-2.29a.5.5 0 0 1 .83.37v9.81a.5.5 0 0 1-.83.37L7.61 14H4.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h3.12Zm5.78 2.25a.4.4 0 0 0-.4.4v.7c0 .22.18.4.4.4h5.2a.4.4 0 0 0 .4-.4v-.7a.4.4 0 0 0-.4-.4h-5.2Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVolumeDownStyle0; }
}, [1, "cosmos-icon-volume-down", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-volume-down"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-volume-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVolumeDown$1);
            }
            break;
    } });
}

const CosmosIconVolumeDown = CosmosIconVolumeDown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVolumeDown, defineCustomElement };
